import React, { useEffect, useState } from "react";
import { StyledHeader } from "./ClubFinancial";
import LabelText from "../../../ui/LabelText";
import DonutRingChart from "./DonutRingChart";
import { IBreakdownRevenue, IDonutRingData } from "../../../types/IClubDetail";

interface ClubRevenueBreakDownProps {
  data: IBreakdownRevenue | undefined;
}

const ClubRevenueBreakDown: React.FC<ClubRevenueBreakDownProps> = ({ data }) => {
  const [donutRingData, setDonutRingData] = useState<IDonutRingData[] | undefined>();

  useEffect(() => {
    setDonutRingData([
      { color: "#00D1A8", value: data?.matchDay, text: data?.matchDayText, label: "Matchday", Inferred: data?.isMatchDayInferred },
      { color: "#FF7800", value: data?.broadCast, text: data?.broadCastText, label: "Broadcast", Inferred: data?.isBroadCastInferred },
      { color: "#FFC2C2", value: data?.commercial, text: data?.commercialText, label: "Commercial", Inferred: data?.isCommercialInferred },
      {
        color: "#C9F0B5",
        value: data?.playerTrading,
        text: data?.playerTradingText,
        label: "Player trading",
        Inferred: data?.isPlayerTradingInferred,
      },
      { color: "#64ADDB", value: data?.other, text: data?.otherText, label: "Other" },
    ]);
  }, [data]);

  return (
    <>
      <StyledHeader className="header-content">
        <LabelText className="drawer-title">Revenue Breakdown</LabelText>
      </StyledHeader>
      <DonutRingChart data={donutRingData} total={data?.totalRevenuesText} />
    </>
  );
};

export default ClubRevenueBreakDown;
